export const AminoConverter = {
  "/juno.feeshare.v1.MsgRegisterFeeShare": {
    aminoType: "/juno.feeshare.v1.MsgRegisterFeeShare",
    toAmino: ({
      contractAddress,
      deployerAddress,
      withdrawerAddress
    }) => {
      return {
        contract_address: contractAddress,
        deployer_address: deployerAddress,
        withdrawer_address: withdrawerAddress
      };
    },
    fromAmino: ({
      contract_address,
      deployer_address,
      withdrawer_address
    }) => {
      return {
        contractAddress: contract_address,
        deployerAddress: deployer_address,
        withdrawerAddress: withdrawer_address
      };
    }
  },
  "/juno.feeshare.v1.MsgUpdateFeeShare": {
    aminoType: "/juno.feeshare.v1.MsgUpdateFeeShare",
    toAmino: ({
      contractAddress,
      deployerAddress,
      withdrawerAddress
    }) => {
      return {
        contract_address: contractAddress,
        deployer_address: deployerAddress,
        withdrawer_address: withdrawerAddress
      };
    },
    fromAmino: ({
      contract_address,
      deployer_address,
      withdrawer_address
    }) => {
      return {
        contractAddress: contract_address,
        deployerAddress: deployer_address,
        withdrawerAddress: withdrawer_address
      };
    }
  },
  "/juno.feeshare.v1.MsgCancelFeeShare": {
    aminoType: "/juno.feeshare.v1.MsgCancelFeeShare",
    toAmino: ({
      contractAddress,
      deployerAddress
    }) => {
      return {
        contract_address: contractAddress,
        deployer_address: deployerAddress
      };
    },
    fromAmino: ({
      contract_address,
      deployer_address
    }) => {
      return {
        contractAddress: contract_address,
        deployerAddress: deployer_address
      };
    }
  }
};